module.exports = __webpack_public_path__ + "static/media/se.252272e3.svg";